"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkRaffle = exports.isRaffle = void 0;
const __1 = require("..");
function isRaffle(object) {
    return checkRaffle(object).fulfilled;
}
exports.isRaffle = isRaffle;
function checkRaffle(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return (0, __1.check)(object, (0, __1.hasString)("id"), (0, __1.hasNumber)("startTime").integer(), (0, __1.hasNumber)("endTime").integer(), (0, __1.hasNumber)("resultTime").integer(), (0, __1.hasBoolean)("paused"), (0, __1.hasNumber)("maxNumberOfPrizes").integer(), (0, __1.hasArray)("winners", (0, __1.isRecord)((0, __1.hasString)("ticketId"), (0, __1.hasNumber)("winningRank"))).optional().nullable()).withOptions(options).explain();
}
exports.checkRaffle = checkRaffle;
//# sourceMappingURL=Raffle.js.map